import clock from '~/assets/icons/clock.svg';
import { useEffect, useRef } from 'react';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { formatTime } from '~/shared';
import { StyledContainer, StyledTimerContainer } from './TaskTimer.styled';

const TaskTimer = ({
	taskExpire,
	span,
}: {
	taskExpire: number;
	span?: number;
}) => {
	const timerTextRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const targetTime = new Date(taskExpire);

		const updateTimeDifference = () => {
			if (!timerTextRef.current) return;
			const diff = targetTime.getTime() - Date.now();
			timerTextRef.current.textContent = formatTime(
				Math.max(0, diff),
				'{hh}:{mm}:{ss}',
			);
		};

		updateTimeDifference();
		const intervalId = setInterval(updateTimeDifference, 1000);

		return () => clearInterval(intervalId);
	}, [taskExpire]);

	return (
		<StyledContainer $span={span}>
			<Text
				style={{
					fontSize: 14,
					color: '#FFFFFF',
					opacity: 0.5,
					fontStyle: 'italic',
				}}
			>
				Данная задача обновится через
			</Text>
			<StyledTimerContainer>
				<ImgIcon icon={clock} width={16} height={16} color="#FFB500" />
				<Text
					ref={timerTextRef}
					style={{ fontSize: 14, color: '#FFB500', fontWeight: 700, width: 64 }}
				>
					00:00:00
				</Text>
			</StyledTimerContainer>
		</StyledContainer>
	);
};

export { TaskTimer };
